import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import AvatarUploader from '@blade/common/components/avatar-uploader.vue';
import { StaffModule } from '@blade-sxp/pass/store/staff';
import { handleError } from '@blade/common/utils/handle-error';
import { EType } from '@blade/common/interfaces/user-group';
import EditMessages, { CreateStaff } from '@blade-sxp/pass/lang/edit';
import moment from 'moment';
import { merge } from 'lodash';
import GenderSelect from '@blade-sxp/pass/components/gender-select.vue';
import { overlapGroup } from '@blade-sxp/pass/utils/overlap-group';
import EncryptInput from '@blade/common/components/encrypt-input.vue';
let default_1 = class extends Vue {
    title = '';
    remoteAvatarURL = '';
    currId = 'CREATE';
    form = {
        name: '',
        gender: '',
        portraitLibIds: [],
        workId: '',
        countryId: '',
        phone: '',
        dept: '',
        company: '',
        email: '',
        icCard: '',
        address: '',
        birthDay: '',
        identityId: '',
        image: '',
    };
    tags = [
        { name: 'Tag 1', key: 0 },
        { name: 'Tag 2', key: 1 },
        { name: 'Tag 3', key: 2 },
        { name: 'Tag 4', key: 3 },
        { name: 'Tag 5', key: 4 },
    ];
    avatar = '';
    options = [{ label: 'staff1', value: '1' }];
    id = '';
    get whitegroup() {
        return {
            name: {
                required: true,
                trigger: ['blur', 'change'],
                validator: (rule, value, callback) => {
                    if (!this.form.name) {
                        callback(new Error(this.$t('nameError').toString()));
                    }
                    else {
                        callback();
                    }
                },
            },
            portraitLibIds: {
                required: true,
                trigger: ['blur', 'change'],
                validator: (rule, value, callback) => {
                    if (this.form.portraitLibIds.length === 0) {
                        callback(new Error(this.$t('groupError').toString()));
                    }
                    else {
                        callback();
                    }
                },
            },
            image: {
                required: true,
                trigger: ['blur', 'change'],
                validator: (rule, value, callback) => {
                    if (!this.form.image) {
                        callback(new Error(this.$t('imageError').toString()));
                    }
                    else {
                        callback();
                    }
                },
            },
        };
    }
    handleClose(e) {
        console.log('e:', e);
    }
    handleDelete() {
        this.tags = [];
    }
    handleAvatar(url) {
        this.form.image = url;
    }
    async mounted() {
        const { meta, params } = this.$route;
        console.log('router:', meta);
        this.title = meta.page;
        this.id = params.id;
        await this.getPortraitIds();
        this.resetForm();
        if (meta.page === 'editPortrait') {
            this.currId = 'EDIT';
            this.getData();
        }
    }
    async getData() {
        try {
            const res = await StaffModule.getPortraitById(this.id);
            console.log('res:', res);
            const { data } = res;
            if (!data) {
                return;
            }
            const { phone, countryId, url } = data;
            if (url) {
                this.remoteAvatarURL = url;
            }
            this.form = {
                name: data.name,
                gender: data.gender,
                portraitLibIds: overlapGroup(data.portraitLibIds, this.options),
                workId: data.workId,
                phone,
                countryId: countryId?.substr(0, 10) || '',
                dept: data.dept,
                company: data.company,
                email: data.email,
                icCard: data.icCard,
                address: data.address,
                birthDay: data.birthDay,
                identityId: data.identityId,
                image: data.url,
            };
            console.log('form:', this.form);
        }
        catch (e) {
            console.log('e:', e);
        }
    }
    handleSubmit() {
        this.$refs['staff-form'].validate((valid) => {
            if (valid) {
                this.form.birthDay =
                    this.form.birthDay === '' || this.form.birthDay === null || this.form.birthDay === 'Invalid date'
                        ? ''
                        : moment(this.form.birthDay).format('YYYY-MM-DD');
                if (this.title === 'createPortrait') {
                    this.createStaff();
                }
                else {
                    this.updateStaff();
                }
            }
            else {
                console.log('error submit!!');
                return false;
            }
        });
    }
    async createStaff() {
        try {
            await StaffModule.createPasssstaff(this.form);
            this.$elmessage.success(this.$t('createSuccess').toString());
            this.$router.push({ path: '/users/portraitmanagement/pass/portrait', query: { group: 'STAFF' } });
        }
        catch (e) {
            handleError(e);
        }
    }
    handleCancel() {
        this.$router.push({ path: '/users/portraitmanagement/pass/portrait', query: { group: 'STAFF' } });
    }
    genderChange(v) {
        this.form.gender = v;
    }
    async getPortraitIds() {
        try {
            const res = await StaffModule.getPortraitsGroup({ data: EType.USER, mode: this.currId });
            const mappedIds = this.mapOptions(res.data);
            this.options = mappedIds;
        }
        catch (e) { }
    }
    mapOptions(data) {
        const res = data.map((item) => {
            return { label: item.name, value: item.libId };
        });
        return res;
    }
    async updateStaff() {
        console.log('form:', this.form);
        try {
            await StaffModule.updatePortrait({
                paramStaff: { ...this.form },
                id: this.id,
            });
            this.$elmessage.success(this.$t('editSuccess').toString());
            this.$router.push({ path: '/users/portraitmanagement/pass/portrait', query: { group: 'STAFF' } });
        }
        catch (e) {
            handleError(e);
        }
    }
    resetForm() {
        console.log('resetForm');
        this.form = {
            name: '',
            gender: '',
            portraitLibIds: [],
            workId: '',
            countryId: '',
            phone: '',
            dept: '',
            company: '',
            email: '',
            icCard: '',
            address: '',
            birthDay: '',
            identityId: '',
            image: '',
        };
    }
};
default_1 = __decorate([
    Component({
        name: 'WhiteStaff',
        components: { AvatarUploader, GenderSelect, EncryptInput },
        i18n: {
            messages: {
                'en-us': {
                    id: 'User id',
                    phone: 'Phone Number',
                    dept: 'Department',
                    position: 'Position',
                    email: 'Email',
                    ic: 'IC Card',
                    address: 'Working Addr',
                    birthday: 'Birthday',
                    createWhite: 'Create Portrait',
                    groupName: 'Portrait Library Name',
                    groupAccess: 'Portrait Library Access',
                    access: 'Please input name/organization',
                    submit: 'Submit',
                    cancel: 'Cancel',
                    editWhite: 'Edit Portrait',
                    name: 'Name',
                    gender: 'Gender',
                    whitegroup: 'Portrait Library (multiple supported)',
                    nameError: 'Name is required',
                    groupError: 'Please input Portrait Library',
                    imageError: 'Please input image',
                    createPortrait: 'Create Portrait',
                    editPortrait: 'Edit Portrait',
                },
                zh: {
                    id: '人像工号',
                    phone: '手机号码',
                    dept: '部门',
                    position: '职位',
                    email: '邮箱',
                    ic: 'IC卡号',
                    address: '工作地点',
                    birthday: '出生日期',
                    createWhite: '创建人像',
                    groupName: '人像库名称',
                    groupAccess: '人像库权限',
                    access: '请输入姓名/部门',
                    submit: '确认',
                    cancel: '取消',
                    editWhite: '编辑人像',
                    name: '姓名',
                    gender: '性别',
                    whitegroup: '所属人像库（可多选）',
                    nameError: '请填名字',
                    groupError: '请选人像库',
                    imageError: '请选头像',
                    createPortrait: '创建人像',
                    editPortrait: '修改人像',
                },
            },
            sharedMessages: merge({}, EditMessages, CreateStaff),
        },
    })
], default_1);
export default default_1;
